<template>
    <ul :class='"list list-" + $parent.model'>

        <router-link tag='li' :to='$parent.getOpenLink(null, item.id)' v-for="item in $parent.items.data" :key='item.id' :class='"list-" + $parent.model + "_item"'>
            <!-- ID: {{item.id}}<br /> -->
            <!-- @updatehere -->
            <h2 class="h6">{{item.name}}</h2>
			<br />
        </router-link>
    </ul>
</template>

<script>
    export default {
        props: [
        ],
        data: function() {
            return {
			//	item: 'test'
			};
        },
        methods: {
            
        }
    }
</script>
